import React, { useEffect, useState } from 'react';
import Navbar from './components/navbar/Navbar.js';
import Hero from './components/client/C3/Hero/Hero.js';
import ReserveButton from './components/ReserveButton/ReserveButton.js';
import InfoPanel from './components/Info-Panel/InfoPanel.js';
// import ProductPanel from './components/product-panel/ProductPanel.js';
import ProductModal from './components/product-modal/ProductModal.js';
import InfoModal from './components/info-modal/InfoModal.js';
import Footer from './components/footer/Footer.js';
import Gallery from './components/Gallery/Gallery.js';
import LaunchCountdown from './components/LaunchCountdown/LaunchCountdown.js';

import './App.css';
import 'bulma/css/bulma.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './components/client/C3/C3Styles.css'; //TODO: better location for this

import axios from 'axios';

import PRODUCT_DATA from './data/Products.js';
import HERO_DATA from './data/Hero.js';
import APP_DATA from './data/App.js';
import FAQ_DATA from './data/FAQ.js';


const ax = axios.create({
  baseURL: APP_DATA.baseUrl
});

console.log(PRODUCT_DATA[0]);
function App() {
  const [infoModalActive, setInfoModalActive] = useState(false);
  const [productModalActive, setProductModalActive] = useState(false);
  const [hasLaunched, setHasLaunched] = useState(new Date(APP_DATA.launchDate) - new Date() <= 0);
  // const [products] = useState(PRODUCT_DATA);
  // const [activeProduct, setActiveProduct] = useState(APP_DATA?.preloadedProductIndex >= 0 ? PRODUCT_DATA[APP_DATA.preloadedProductIndex] : null);
  const [activeProduct, setActiveProduct] = useState(PRODUCT_DATA[0]);
  // const [isBasicLayout, setIsBasicLayout] = useState(true);
  const [reservedTimer, setReservedTimer] = useState(null);
  const [captchaUserResponsetoken, setCaptchaUserResponseToken] = useState(null);
  const [productStats, setProductStats] = useState(null);

  useEffect(() => {
    document.title = APP_DATA.title;
  }, [])

  useEffect(() => {
    async function getStats() {
      let res;
      try {
        res = await ax.get('/stats');
        setProductStats(res.data.productStats);
      } catch (e) {
        console.warn("Unable to load Stats", e);
        setProductStats(null);
      }
      console.log(res);
    }

    getStats();
  }, []);

  // useEffect(() => {
  //   const isSingleProduct = products.length === 1;
  //   const containsBundle = products.some(p => p.bundleQty);
  //   setIsBasicLayout(isSingleProduct && !containsBundle)
  // }, [products]);


  const [reservationStatus, setReservationStatus] = useState(null);
  useEffect(() => {
    async function fetchReservation() {
      let res;
      try {
        res = await ax.get(`/reserve/${activeProduct.type}`, { params: { captchaToken: captchaUserResponsetoken } });
      } catch (error) {
        setReservationStatus("SERVER_ERROR");
        return;
      }

      let error_code = res.data.payload.error_code;
      //error_code "1" means too many tokens requested in a short time
      if (error_code === 1) {
        setActiveProduct(p => ({ ...p, data: res.data }));
        setReservationStatus("COOLDOWN");
        return;
      }

      //error_code "2" means all tokens are sold out or reserved
      if (error_code === 2) {
        //TODO: handle case of all reserved or sold
        setReservationStatus("SOLD_OUT");
        return;
      }

      if (error_code === 5) {
        //TODO: handle case of all reserved or sold
        console.log("Unable to confirm humanity");
        setReservationStatus("SERVER_ERROR");
        return;
      }

      setActiveProduct(p => ({ ...p, data: res.data }));
      setReservedTimer(res.data.payload.timer);
      setReservationStatus("RESERVED");
    }

    async function fetchStatus() {
      const { key, reserve_hash } = activeProduct.data.payload;
      let res;
      try {
        res = await ax.get(`/status/${key}/${reserve_hash}`);
      } catch (error) {
        setReservationStatus("SERVER_ERROR");
        return;
      }

      if (res.data.status) {
        //handle transaction successful
        setActiveProduct(p => ({ ...p, data: res.data }));
        setReservationStatus("SUCCESS");
      }
      else {
        //check if error === 3, thats status code for expired
        if (res.data.payload.error === 3) {
          setReservationStatus("EXPIRED");
          return;
        }
        //otherwise update timer 
        setReservedTimer(res.data.payload.timer)
      }
    }

    let statusIntervalId = null;
    switch (reservationStatus) {
      case "LOADING":
        fetchReservation();
        break;
      case "RESERVED":
        statusIntervalId = setInterval(fetchStatus, 10000);
        break;
      default:
        break;
    }
    return () => {
      clearInterval(statusIntervalId);
    }
    //deps not listed in array below are fine because we're relying on reservation state
    //comment below removes linter warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationStatus]);

  const reserveProduct = (product) => {
    setReservationStatus("LOADING");
  }

  const checkHumanity = (product) => {
    setActiveProduct(product);
    setReservationStatus("CAPTCHA");
    toggleProductModal();
  }


  const expireReservation = () => {
    setReservationStatus("EXPIRED");
  }

  const toggleInfoModal = () => {
    setInfoModalActive(isActive => !isActive);
  }

  const toggleProductModal = () => {
    setProductModalActive(isActive => !isActive);
  }

  //might be able to roll this into a custom hook
  const hasInventory = (product_type) => {
    if (productStats) {
      try {
        return productStats[product_type].available > 0;
      } catch (e) {
        console.warn(`Unable to determine if "${product_type}" has inventory. Assuming not.`);
        return false;
      }
    }
  }

  const { title, tagline, blurb } = HERO_DATA;
  const images = ['/v1.png', '/v2.png', '/v3.png', '/v4.png', 'v5.png'];
  
  
  return (
    <>

      <Navbar />  

      <Hero title={title} tagline={tagline} blurb={blurb} />
      <section className="section">
        <div className="container is-widescreen">
          <div className="columns">
            <div className="column">
              <Gallery images={images} width="200 px" />
              <p id="c2a-message" className="title is-2 has-text-centered">Don't miss out. Get 1 of 5 random <span id="c2a-emphasis">tubular</span> NFTs {hasLaunched ? "now!" : "in: "}</p>
              <div className="has-text-centered">
                {hasLaunched && <ReserveButton
                  id="c2a-button"
                  subject={activeProduct}
                  disabled={!hasInventory(activeProduct?.type)}
                  action={checkHumanity}
                  text="RESERVE TOKEN!"
                  disabledText="RESERVATIONS CLOSED"
                />
                }
                {!hasLaunched && <LaunchCountdown launchDate={APP_DATA.launchDate} expireReservation={() => setHasLaunched(true)} />}
              </div>
            </div>


          </div>
        </div>
      </section>
      <section id="faq-section" className="section">
        <div className="container is-max-desktop">
          <h2 id="faq-header" className="title is-1 has-text-centered">FAQ</h2>
          <div className="columns is-variable is-4">
          {FAQ_DATA.map((item, i) => {
            return (
              <InfoPanel item={item} key={i} />
            )
          })}
          </div>

          <p id="policy-id">Policy ID: <span id="policy-id-value">{APP_DATA.policyId}</span></p>
          
        </div>
      </section>
      <section id="shop-canuckz-section">
        <div className="container is-max-widescreen is-flex is-flex-direction-row-reverse is-align-items-center p-3">
        <a href="https://canuckz-nft.io/buy" alt="Canuckz NFT Store" id="shop-canuckz-button" className="button">Buy</a>
          <p id="shop-canuckz-message" className="title is-3">Want more Canadian NFTs? Shop Canuckz </p>
        </div>
      </section>
      {/* <div id="panel-section" className="section container is-fluid pb-6">
        <div className="content">
          <div className={`columns is-multiline is-centered ${isBasicLayout && "is-vcentered"}`}>
            {products.map(product => (
              <ProductPanel
                key={product.id}
                product={product}
                productStats={productStats}
                checkHumanity={checkHumanity}
                toggleProductModal={toggleProductModal}
                toggleInfoModal={toggleInfoModal}
                hasInventory={hasInventory}
                layout={isBasicLayout ? 'Basic' : 'Rich'}
              />)
            )}

          
          </div>



        </div>
      </div> */}
      {productModalActive && activeProduct &&
            <ProductModal
              isActive={productModalActive}
              reservedTimer={reservedTimer}
              toggle={toggleProductModal}
              product={activeProduct}
              status={reservationStatus}
              reserveProduct={reserveProduct}
              setCaptchaUserResponseToken={setCaptchaUserResponseToken}
              expireReservation={expireReservation}
            />}
          {infoModalActive &&
            <InfoModal isActive={infoModalActive} toggle={toggleInfoModal} />
          }
      <Footer handleDebugClick={() => checkHumanity(activeProduct)} />
    </>
  );
}

export default App;
